module.exports = __webpack_public_path__ + "static/media/kouiKutushita2.62650899.png";